import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 400,
    marginTop: theme.spacing(6),
    gap: theme.spacing(2)
  },
  card: {
    display: 'flex',
    width: '360px',
    flexDirection: 'column',
    background: theme.colorPalette.green_90,
    padding: theme.spacing(6),
    borderRadius: theme.sizes.roundCorners,
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  row: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center'
  },
  titleColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1)
  },
  code: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.orange_75,
    ...reskinStyles(theme, { color: theme.colorPalette.orange_50 })
  },
  title: {
    color: theme.onCard.white,
    fontSize: 20,
    lineHeight: '24px',
    fontWeight: 600
  },
  branchPlusEligible: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colorPalette.green_80,
    color: theme.onCard.beige_25,
    borderRadius: theme.spacing(4),
    padding: theme.spacing(0, 2),
    height: 26,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    ...reskinStyles(theme, theme.labelStyles.outlined)
  },
  subtitle: {
    textAlign: 'left',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.onCard.beige_25
  },
  iconRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    fontSize: 10,
    fontWeight: 600,
    lineHeight: '12px',
    color: theme.onCard.white
  },
  subBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    border: `2px solid ${theme.onCardDivider.green_80}`,
    borderRadius: 4,
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    ...reskinStyles(theme, theme.cardStyles.inset)
  },
  boxContent: {
    textAlign: 'left',
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 400,
    color: theme.onCard.white
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  overrideButton: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 24,
    width: '100%'
  },
  overrideCheckbox: {
    color: theme.onCard.white
  },
  inaccurateButton: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 24
  },
  simulatedBadge: {
    '&&': {
      maxWidth: 'none',
      backgroundColor: theme.colorPalette.white_30,
      color: theme.colorPalette.beige_90,
      ...reskinStyles(theme, theme.labelStyles.outlined)
    }
  }
}));

export default useStyles;
